import { CURRI_VERSION } from '../../auth/AuthProvider.tsx'
import { navigateOnPlainClick } from '../../shell/links.ts'
import { BarcodeStamp } from './Barcode.tsx'

// The hero's left column: eyebrow, headline, the two paths into the portal,
// and the provenance row. The code console beside it is its own component —
// this one is static copy. Each block staggers in via `landing-up`, with the
// delay carried inline.

export const Hero = ({
  onNavigate,
}: {
  onNavigate: (path: string) => void
}) => (
  <div style={{ flex: '1 1 400px', minWidth: 'min(360px, 100%)', maxWidth: 560 }}>
    <div
      className="landing-up"
      style={{ display: 'flex', alignItems: 'center', gap: 14 }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.08em',
          color: 'var(--curri-text-secondary)',
        }}
      >
        BUILD · DEVELOPER PLATFORM
      </span>
      <BarcodeStamp tone="strong" />
    </div>

    <h1
      className="landing-up"
      style={{
        margin: '14px 0 0',
        fontSize: 'clamp(40px, 5vw, 62px)',
        lineHeight: 1.1,
        animationDelay: '0.03s',
      }}
    >
      Ship with Curri
    </h1>
    <p
      className="landing-up"
      style={{
        margin: '18px 0 0',
        fontSize: 17,
        lineHeight: 1.6,
        color: 'var(--curri-text-secondary)',
        maxWidth: '46ch',
        textWrap: 'pretty',
        animationDelay: '0.06s',
      }}
    >
      One API for construction and industrial delivery — quoting, booking,
      tracking, and the webhooks that tell you what happened.
    </p>

    {/* Sized by the buttons row, so the provenance row below can align its
        outer edges to the buttons' outer edges. */}
    <div style={{ width: 'fit-content' }}>
      <div
        className="landing-up"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginTop: 28,
          animationDelay: '0.12s',
        }}
      >
        {/* Anchors styled as the BUILD design's buttons (landing.css), not
            `<Button>` with a `render` anchor: Base UI insists on button
            semantics either way (`role="button"` when told the element isn't
            native), and these are real links — cmd-click and "open in new tab"
            must keep working. Not `buttonVariants` either: the component
            library's palette puts green text on both, where the design carries
            ink text on the brand fill and on the outline. */}
        <a
          className="landing-btn landing-btn-brand"
          href="/docs/graphql"
          onClick={navigateOnPlainClick(onNavigate, '/docs/graphql')}
        >
          Read the docs
        </a>
        <a
          className="landing-btn landing-btn-outline"
          href="/dashboard/webhooks"
          onClick={navigateOnPlainClick(onNavigate, '/dashboard/webhooks')}
        >
          Open the dashboard
        </a>
      </div>

      {/* Spread across the buttons' width: the copy sits on the left button's
          edge, the health readout's right edge on the right button's. */}
      <div
        className="landing-up"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '16px 44px',
          marginTop: 30,
          animationDelay: '0.18s',
        }}
      >
        <div
          style={{
            fontSize: 12,
            lineHeight: 1.5,
            color: 'var(--curri-text-secondary)',
          }}
        >
          built in
          <br />
          california
        </div>
        <div
          style={{
            fontFamily: 'var(--curri-font-mono)',
            fontSize: 12,
            lineHeight: 1.5,
            color: 'var(--curri-text-tertiary)',
          }}
        >
          GET /api/health <span aria-hidden="true">→</span>{' '}
          <span style={{ color: 'var(--curri-accent)', fontWeight: 600 }}>
            200 ok
          </span>
          <br />
          curri-version {CURRI_VERSION}
        </div>
      </div>
    </div>
  </div>
)
